import './../../styles/footer.css'

import React from 'react';

const Footer = () =>  (
    
        <footer className="credits">
        Made by insomnia1337. All credits to afonsopacifer
        </footer>

    );


export default Footer;


// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js